import { z } from "zod";

export const submitVoiceGuesserAnswerSchema = z.object({
	round: z.number().int().nonnegative(),
	guessed_user_id: z.string().min(1),
	answered_at: z.number().int().positive(),
});

export type SubmitVoiceGuesserAnswerPayload = z.infer<typeof submitVoiceGuesserAnswerSchema>;
